<template>
  <dialog @click.stop class="dialog" open>
    <button @click="emitHide" class="close-button">
      <Fai :icon="['fas', 'times']" />
    </button>
    <IdeaCoachForm
      v-if="isFirstStep"
      :type="type"
      :instructions="instructions"
      @submit="submitText"
      @cancel="emitHide"
    />
    <div class="loading" v-else-if="isLoadingStep">
      <Loading />
    </div>
    <IdeaCoachSelection
      v-else-if="isSecondStep"
      :type="type"
      :suggestions="suggestions"
      @submit="emitSubmit"
      @cancel="emitHide"
      @reset="submitText"
    />
  </dialog>
</template>

<script>
import { mapGetters } from "vuex";
import http from "../../services/axios";
import IdeaCoachForm from "./IdeaCoachForm";
import IdeaCoachSelection from "./IdeaCoachSelection";
import {
  IDEA_COACH_TYPE,
  GET_BACKEND_URL,
  GET_HTTP_CONFIG,
  GET_IN_PROGRESS_STUDY_CURRENT_QUESTION_INDEX,
  GET_IDEA_COACH_STATE,
  A_UPDATE_IDEA_COACH_STATE,
} from "../../services/constants";

const instructions = {
  questions:
    "Use the BimiLeap Idea Coach to help formulate your four questions. Simply type in a short description of your idea, product, or whatever you are creating this study for and click submit. The Idea Coach will return up to 15 questions. You can use these questions as is, edit them, or write in your own.",
  answers:
    "Use the BimiLeap Idea Coach to help formulate answers for this question. The Idea Coach will take the question and return up to 15 answers. You can use these answers as is, edit them or write in your own. The answers to these questions will be used to formulate the vignettes of the study.",
};

export default {
  name: "IdeaCoachDialog",
  props: {
    type: {
      type: String,
      default: "",
    },
  },
  components: { IdeaCoachForm, IdeaCoachSelection },
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      GET_IDEA_COACH_STATE,
      GET_IN_PROGRESS_STUDY_CURRENT_QUESTION_INDEX,
      GET_BACKEND_URL,
      GET_HTTP_CONFIG,
    ]),
    isFirstStep() {
      return this.currentStep === 1;
    },
    isSecondStep() {
      return this.currentStep === 2;
    },
    isLoadingStep() {
      return this.currentStep === "loading";
    },
    instructions() {
      if (this.type === IDEA_COACH_TYPE.question) {
        return instructions.questions;
      }
      return instructions.answers;
    },
    currentStep() {
      return this[GET_IDEA_COACH_STATE].currentStep;
    },
    suggestions() {
      return this[GET_IDEA_COACH_STATE].suggestions;
    },
  },
  methods: {
    emitHide() {
      this.$emit("hide");
    },
    submitText(text) {
      const studyId = this.$store.state.dataModule.getStudyState.data.id
      if (this.type === IDEA_COACH_TYPE.question) {
        this.$store.dispatch(A_UPDATE_IDEA_COACH_STATE, { currentStep: "loading" });
        http
          .post(
            this[GET_BACKEND_URL](`data/suggestions/questions`),
            { studyId, text },
            this[GET_HTTP_CONFIG]
          )
          .then((res) => {
            let { data } = res;
            this.$store.dispatch(A_UPDATE_IDEA_COACH_STATE, { suggestions: data });
            this.$store.dispatch(A_UPDATE_IDEA_COACH_STATE, { currentStep: 2 });
          });
      } else {
        this.$store.dispatch(A_UPDATE_IDEA_COACH_STATE, { currentStep: "loading" });
        const i = this[GET_IN_PROGRESS_STUDY_CURRENT_QUESTION_INDEX];
        const questionObj = this.$store.state.dataModule.inProgressStudy.questions[i];
        http
          .post(
            this[GET_BACKEND_URL](`data/suggestions/answers`),
            { studyId: studyId, text: questionObj.text },
            this[GET_HTTP_CONFIG]
          )
          .then((res) => {
            let { data } = res;
            this.$store.dispatch(A_UPDATE_IDEA_COACH_STATE, { suggestions: data });
            this.$store.dispatch(A_UPDATE_IDEA_COACH_STATE, { currentStep: 2 });
          });
      }
    },
    emitSubmit() {
      this.$emit("submit");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main";

.dialog {
  background: $white-1;
  border-radius: 10px;
  overflow: hidden;
  width: 500px;
  height: 500px;
  padding: 2rem 1.25rem;
  border: solid;
  @media #{$mobile} {
    width: 100%;
    height: 100%;
    padding: 0;
    border: none;
  }
}

.close-button {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background: none;
  border: none;
}

.loading {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}
</style>
